var iterator = require('markdown-it-for-inline');
var markdownItScrollTable = require('markdown-it-scrolltable');

const ESCAPE_TAG_MAP = {
    "<script": "&lt;script",
    "<link": "&lt;link",
    "<title": "&lt;title",
    "<meta": "&lt;meta",
};

const ESCAPE_CUSTOM_TAG_MAP = {
    "<thinking>": '<div class="alan-special-markdown-tag-wrapper"><span class="alan-special-markdown-tag-hl-green">&lt;thinking&gt;</span>',
    "</thinking>": '<span class="alan-special-markdown-tag-hl-green">&lt;/thinking&gt;</span></div>',
    "<reasoning>": '<div class="alan-special-markdown-tag-wrapper"><span class="alan-special-markdown-tag-hl-green">&lt;reasoning&gt;</span>',
    "</reasoning>": '<span class="alan-special-markdown-tag-hl-green">&lt;/reasoning&gt;</span></div>',
    "[[Reasoning]]": '<span class="alan-special-markdown-tag-hl-blue">[[Reasoning]]</span></div>',
    "[[Has-Answer]]": '<span class="alan-special-markdown-tag-hl-blue">[[Has-Answer]]</span></div>',
    "[[Short-Answer]]": '<span class="alan-special-markdown-tag-hl-blue">[[Short-Answer]]</span></div>',
    "[[Full-Answer]]": '<span class="alan-special-markdown-tag-hl-blue">[[Full-Answer]]</span></div>',
    "[[Images]]": '<span class="alan-special-markdown-tag-hl-blue">[[Images]]</span></div>',
    "[[Links]]": '<span class="alan-special-markdown-tag-hl-blue">[[Links]]</span></div>',
    "N/A": '<span class="alan-special-markdown-tag-hl-grey">N/A</span></div>',
    "YES": '<span class="alan-special-markdown-tag-hl-green">YES</span></div>',
    "NO": '<span class="alan-special-markdown-tag-hl-red">NO</span></div>',
};

export function alanMarkdown(str = '') {
    var md = require('markdown-it')({ html: true, breaks: true })
        .use(require('markdown-it-footnote'))
        .use(markdownItScrollTable)
        .use(iterator, 'url_new_win', 'link_open', function (tokens, idx) {
            tokens[idx].attrSet('target', '_blank');
        });
    return sanitize(md.render(sanitizeCustomTags(str || '')));
}

function sanitizeCustomTags(str) {
    let result = str;

    for (const [tag, replacement] of Object.entries(ESCAPE_CUSTOM_TAG_MAP)) {
        const tagRegex = new RegExp(tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
        result = result.replace(tagRegex, replacement);
    }

    return result;
}

function sanitize(str) {
    let tag = '';
    let result = '';
    for (let i = 0; i < str.length; i++) {
        if (str[i] === '<') {
            while (true) {
                tag += str[i];
                i++;
                if (str[i] === ' ' || str[i] === '>' || i >= str.length) {
                    tag += str[i];
                    break;
                }
            }
            if (tag !== '') {
                result += tag;
                tag = '';
            }
        } else {
            result += str[i];
        }

    }
    return result;
}

function escapeHtml(text) {
    let resultStr = text;

    for (const key in ESCAPE_TAG_MAP) {
        var r = new RegExp(`${key}`, 'gi');
        resultStr = String(resultStr).replace(r, ESCAPE_TAG_MAP[key]);
    }

    return resultStr;
}